import { render, staticRenderFns } from "./explanationBox.vue?vue&type=template&id=64d9090e&"
import script from "./explanationBox.vue?vue&type=script&lang=js&"
export * from "./explanationBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports